import { render, staticRenderFns } from "./ParticipacaoTotalJurosPercentual.vue?vue&type=template&id=27ee03c2&scoped=true&"
import script from "./ParticipacaoTotalJurosPercentual.vue?vue&type=script&lang=js&"
export * from "./ParticipacaoTotalJurosPercentual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ee03c2",
  null
  
)

export default component.exports